var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 10,
    viewBox: "0 0 5 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.88546 3.11436C4.89214 4.12105 4.9257 5.73236 3.98612 6.77935L3.88546 6.8856L1.13916 9.47138C0.878813 9.73173 0.456703 9.73173 0.196353 9.47138C-0.0439693 9.23106 -0.0624559 8.85291 0.140894 8.59138L0.196353 8.52858L2.94265 5.94279C3.43594 5.44949 3.4619 4.66584 3.02053 4.14198L2.94265 4.05717L0.196353 1.47138C-0.0639972 1.21104 -0.0639972 0.788925 0.196352 0.528576C0.436675 0.288253 0.814829 0.269766 1.07636 0.473116L1.13916 0.528575L3.88546 3.11436Z",
    fill: "#6C727F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftarrow);
export default __webpack_public_path__ + "static/media/leftarrow.8059d44674c1e248114af258eaa68e8f.svg";
export { ForwardRef as ReactComponent };